import React, { useState } from "react";
import Logo from "../img/logo.png";

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <a className="navbar-brand" href="/">
            <img src={Logo} alt="Logo" />
          </a>

          <button
            type="button"
            className="navbar-toggle collapsed visible-xs"
            onClick={toggleMenu}
          >
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>

          <div
            className={`collapse navbar-collapse ${isOpen ? "in" : ""}`}
            id="bs-example-navbar-collapse-1"
            style={{ textAlign: "right" }}
          >
            <ul className="nav navbar-nav navbar-right">
              <li><a href="#features" className="page-scroll">О нас</a></li>
              <li><a href="#about" className="page-scroll">Направления</a></li>
              <li><a href="#services" className="page-scroll">Психология</a></li>
              <li><a href="#portfolio" className="page-scroll">Образование</a></li>
              <li><a href="#testimonials" className="page-scroll">Продакшн</a></li>
              <li><a href="#projects" className="page-scroll">Проекты</a></li>
              <li><a href="#contact" className="page-scroll">Оставить заявку</a></li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};
